import axios from 'src/utils/axios';
import { HOST_API } from '../config';
import { sha256 } from 'js-sha256';

export async function getCptFromTreatment(treatment)
{
    return await axios.post("/underwriting/cnpl/get_cpt_codes_of_treatment",{'treatment': treatment}, {headers:{Accept:'*/*'}})
}

export async function getCostRange(treatment, purpose, insurer, healthPlan, location, hospital, clinic)
{
    return await axios.post("/underwriting/cnpl/get_cost_range",{
        treatment, purpose, insurer, healthPlan, location, hospital, clinic
    }, {headers:{Accept:'*/*'}})
}


export async function getCreditLimits(age, gender, incomeBucket, dependents, memberLocation, creditScore, paymentHistory, creditUtilization, largeExpenses, potentialOutcomeScore, proprietaryScore1, proprietaryScore2)
{
    return await axios.post("/underwriting/cnpl/get_credit_limits",{
        age, gender, incomeBucket, dependents, memberLocation, creditScore, paymentHistory, creditUtilization, largeExpenses, potentialOutcomeScore, proprietaryScore1, proprietaryScore2
    }, {headers:{Accept:'*/*'}})
}

export async function getEligibilityByMobile(mobile)
{
    return await axios.get("/creditline/application/get_eligibility_by_mobile?mobile="+mobile, {headers:{Accept:'*/*'}})
}

export async function emailPaymentLinkToPatient(applicationId, applicantEmail)
{
    return await axios.post("/creditline/application/send_invite_over_email",{
        applicationId,
        applicantEmail
    }, {headers:{Accept:'*/*'}})
}

export async function smsPaymentLinkToPatient(applicationId, phone)
{
    return await axios.post("/creditline/application/send_invite_over_text_message",{
        applicationId,
        phone
    }, {headers:{Accept:'*/*'}})
}

export async function userLogin(data)
{
    const { email, password } = JSON.parse(data);
    return await axios.post("/account/login", data, {headers:{Accept:'*/*'}})
}

export async function updatePassword(password)
{
    return await axios.post("/account/user/update_password", { 
        'password': sha256(password)
    }, {headers:{Accept:'*/*'}})
}

export async function resetPassword(email)
{
    return await axios.post("/account/user/reset_password", {email}, {headers:{Accept:'*/*'}})
}

export async function requestOtp(mobile, email)
{
    if (mobile) {
        return await axios.post("/account/login/request_otp", {mobile, platform: 'web'}, {headers:{Accept:'*/*'}})
    } else if (email) {
        return await axios.post("/account/login/request_otp", {email, platform: 'web'}, {headers:{Accept:'*/*'}})
    }
}

export async function resendOtp(mobile, email)
{
    if (mobile) {
        return await axios.post("/account/login/resend_otp", {mobile, platform: 'web'}, {headers:{Accept:'*/*'}})
    } else if (email) {
        return await axios.post("/account/login/resend_otp", {email, platform: 'web'}, {headers:{Accept:'*/*'}})
    }
}

export async function verifyOtp(mobile, otp)
{
    return await axios.get("/account/login/verify_otp?mobile=" + mobile + "&otp=" + otp+"&app=brightpe")
}


export async function getNotifications()
{
    return await axios.get("/account/user/notifications", {headers:{Accept:'*/*'}})
}

export async function getProviderDetails()
{

    return await axios.get("/account/user/data_for_agreement", {headers:{Accept:'*/*'}})
    return {'data': {
        "providerName": "Bright Dental Clinic",
        "providerAddress": "#123, Road 4, Colony 5, City 6, State 7, Country 8, 560001",
        "authorisedPerson": "Dr. Akhila Akula"
    }}
    // return await axios.get("/account/onboarding/get_terms_acceptance_status", {headers:{Accept:'*/*'}})
}

export async function getBasicTermsAcceptance()
{
    return await axios.get("/account/onboarding/get_terms_acceptance_status", {headers:{Accept:'*/*'}})
}

export async function uploadQrPanel(imgObject)
{
    return await axios.post("/account/onboarding/save_qr_panel", {'qrPanelImage': imgObject}, {headers:{Accept:'*/*'}})
}

export async function updateOnboardingEvent(event, attributes=[])
{
    if (attributes.length > 0) {
        return await axios.post("/account/onboarding/update_event", {event, attributes}, {headers:{Accept:'*/*'}})
    } else {
        return await axios.post("/account/onboarding/update_event", {event}, {headers:{Accept:'*/*'}})
    }
}

export async function getCallDetails(callId, agentId)
{
    return await axios.get("/calls/manage/get_details?callId="+callId+"&agentId="+agentId, {headers:{Accept:'*/*'}})
}

export async function callBack(callId, agentId)
{
    return await axios.get("/calls/manage/callback?callId="+callId+"&agentId="+agentId, {headers:{Accept:'*/*'}})
}

export async function updateAgentNotes(callId, agentId, notes)
{
    return await axios.post("/calls/manage/update_agent_notes", {callId, agentId, notes}, {headers:{Accept:'*/*'}})
}

export async function getAgreementSigningStatus()
{
    return await axios.get("/account/onboarding/get_agreement_signing_status", {headers:{Accept:'*/*'}})
}

export async function proceedToAgreementSigning()
{
    return await axios.get("/account/onboarding/proceed_to_agreement_signing", {headers:{Accept:'*/*'}})
}

// --------------------- FAQs

export async function getAllFaqSlugs()
{
    return await axios.get("/other/faqs/slugs?app=brightpay")
}

export async function getArticleContent(faqSlug)
{
    return await axios.get("/helpcenter/articles/get_content?app=brightpay_unity&slug="+faqSlug)
}

export async function getFeaturedArticles()
{
    return await axios.get("/helpcenter/articles/featured?app=brightpay_unity")
}

export async function getAllFaqCategories()
{
    return await axios.get("/other/faqs/categories?app=brightpay")
}

export async function getFaqsByCategory(faqCategory)
{
    return await axios.get("/other/faqs/list_by_category?app=brightpay&slug="+faqCategory)
}
